import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { isDefined, isNumber } from '@grandvisionhq/utils';

var PricedAddToCartCTA = (_param)=>{
    var { price , priceInterval  } = _param, props = swcHelpers.objectWithoutProperties(_param, [
        "price",
        "priceInterval"
    ]);
    const { getLabel , getFormattedLabel , currency  } = useIntl();
    const priceCaption = React__default.useMemo(()=>{
        if (!isDefined(price)) return null;
        if (isNumber(priceInterval)) {
            return /*#__PURE__*/ React__default.createElement(Text, {
                component: "span",
                variant: "body"
            }, ' (', /*#__PURE__*/ React__default.createElement(Price, {
                value: price,
                currency: currency,
                centAmount: true
            }), ' / ', getFormattedLabel('common.frequency.perDays', {
                labelData: {
                    days: priceInterval
                }
            }), ')');
        }
        if (priceInterval === 'monthly') {
            return /*#__PURE__*/ React__default.createElement(Text, {
                component: "span",
                variant: "body"
            }, ' (', /*#__PURE__*/ React__default.createElement(Price, {
                value: price,
                currency: currency,
                centAmount: true
            }), ' / ', getLabel('common.frequency.perMonth'), ')');
        }
        return /*#__PURE__*/ React__default.createElement(Text, {
            component: "span",
            variant: "body"
        }, ' ', /*#__PURE__*/ React__default.createElement(Price, {
            value: price,
            currency: currency,
            centAmount: true
        }));
    }, [
        price,
        priceInterval,
        currency,
        getLabel,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React__default.createElement(AddToCart, swcHelpers.extends({
        caption: /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Text, {
            component: "span",
            variant: "body"
        }, getLabel('products.actions.addToCart')), priceCaption)
    }, props));
};

export { PricedAddToCartCTA };
//# sourceMappingURL=PricedAddToCartCTA.js.map
